import { AuthorizationClaims } from 'framework/authorization/AuthorizationClaims';
import { UserAccessRights } from 'framework/authorization/Interfaces';
import { AppRouteBase } from 'framework/components/navigation/Navigation.interfaces';
import { goToRoute } from 'framework/components/navigation/service';

export const redirectsListRoute: AppRouteBase = {
  pageTitle: 'modules.merchandising.redirects.title',
  menuTitle: 'modules.merchandising.redirects.menuTitle',
  path: '/searchadmin/redirects',
  // list/read access
  authClaim: { [AuthorizationClaims.SEARCH_REDIRECTS]: UserAccessRights.Read },
};

export const goToRedirectsListRoute = () => goToRoute(redirectsListRoute);

export const redirectsCreateRoute: AppRouteBase = {
  pageTitle: 'modules.merchandising.redirects.create.title',
  menuTitle: 'modules.merchandising.redirects.create.menuTitle',
  path: '/searchadmin/redirects/create',
  // create/update access
  authClaim: { [AuthorizationClaims.SEARCH_REDIRECTS]: UserAccessRights.ReadWrite },
  parent: redirectsListRoute,
};

export const goToRedirectsCreateRoute = () => goToRoute(redirectsCreateRoute);

export const redirectsEditRoute: AppRouteBase = {
  pageTitle: 'modules.merchandising.redirects.edit.title',
  path: '/searchadmin/redirects/edit/:redirectId',
  // create/update access
  authClaim: { [AuthorizationClaims.SEARCH_REDIRECTS]: UserAccessRights.ReadWrite },
  parent: redirectsListRoute,
};

export const goToRedirectsEditRoute = (redirectId: string) => goToRoute(redirectsEditRoute, { redirectId });


